export default "__VITE_ASSET__DGZWrUT2__"